import { graphql } from "gatsby";
import React from "react";

import ArticleCard from "./components/ArticleCard";
import { Layout } from "../components/Layout";
import TitleAndMeta from "../components/TitleAndMeta";

function Page({ data }) {
  const {
    strapiAbout: {
      slug,
      title,
      updatedAt,
      content: {
        data: { content: html },
      },
    },
  } = data;

  return (
    <Layout isCenter>
      <ArticleCard
        hasShadow={false}
        hasBorder={false}
        hasRelativePosition={false}
        data={{ title, html, updatedAt, description: title, slug }}
      />
    </Layout>
  );
}

export const pageQuery = graphql`
  query {
    strapiAbout {
      title
      slug
      createdAt
      updatedAt
      content {
        data {
          content
        }
      }
    }
  }
`;

export default Page;

export function Head({ data }) {
  const {
    strapiAbout: { slug, title, createdAt, updatedAt },
  } = data;

  return (
    <TitleAndMeta
      slug={slug}
      title={title}
      createdAt={createdAt}
      updatedAt={updatedAt}
      articleAuthor={{}}
    />
  );
}
